export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-100/80 text-primary-700 text-xs font-medium rounded-full mb-5">
              <i className="ri-fire-line text-sm"></i>
              今日实时更新 · 51黑料不打烊
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[56px] leading-tight text-foreground-950 mb-4">
              51黑料
              <span className="block text-primary-500">吃瓜第一线 · 每日最新爆料</span>
            </h1>

            <p className="text-sm text-primary-600/80 font-medium mb-5 tracking-wide">
              全网热点黑料视频 · 今日黑料首页 · 51黑料在线观看入口
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              51黑料吃瓜网是国内领先的娱乐八卦与热点爆料聚合平台，覆盖51黑料网一区二区、51黑料不打烊等热门频道。每日精选最具话题性的黑料视频，通过今日黑料首页实时更新，为百万吃瓜群众提供最快、最全、最真实的在线观看体验。当前正值娱乐圈爆料密集期，多位顶流艺人动态持续追踪中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">独家爆料</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center hidden sm:block">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">全天更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                进入今日黑料首页
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20editorial%20illustration%20of%20breaking%20entertainment%20gossip%20news%20portal%20with%20warm%20coral%20orange%20and%20peach%20color%20palette%2C%20floating%20megaphone%20newspaper%20fragments%20and%20speech%20bubbles%20in%20stylized%20geometric%20composition%2C%20modern%20flat%20design%20with%20soft%20gradients%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20background%20with%20subtle%20texture%2C%20editorial%20magazine%20quality%2C%20dramatic%20but%20clean%20lighting&width=800&height=640&seq=hero-main-heiliao&orientation=landscape"
                alt="51黑料吃瓜网 - 每日最新黑料视频与热点爆料聚合平台视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}